// extracted by mini-css-extract-plugin
export default {"videoSelect":"VideoSelect_videoSelect__6uLw-","videoSelect_mobile":"VideoSelect_videoSelect_mobile__rsonH"};